module.exports = __webpack_public_path__ + "img/merge-orders.736b6dbd.svg";